import { memo } from 'react';
import Box from '../Box/Box';
import PressableIcon from '../PressableIcon/PressableIcon';
import { ItemInfoButtonProps } from './ItemInfoButton.types';

function ItemInfoButton({ onInfo, ...boxProps }: ItemInfoButtonProps) {
  return (
    <Box
      {...boxProps}
      padding="space-100"
      borderRadius="radius-full"
      backgroundColor="primaryBackgroundHover"
    >
      <PressableIcon
        name="info"
        color="darkSurfacePrimary"
        width="space-500"
        height="space-500"
        onPress={onInfo}
      />
    </Box>
  );
}

export default memo(ItemInfoButton);
